import emojiRegex from 'emoji-regex';
import nameInitials from 'name-initials';

/**
 * @param name
 * @returns the initials for the given `name`
 * @see {@link https://github.com/ericvera/name-initials}
 */
const getInitials = (name: string): string =>
  nameInitials(name.replace(emojiRegex(), '').trim()) || name.slice(0, 2);

export default getInitials;
